export default () => {
  const faqAccordion = document.querySelector('.js-faq-accordion')

  if (typeof faqAccordion !== 'undefined' && faqAccordion != null) {
    const faqAccordionBtns = [
      ...document.querySelectorAll('.js-faq-accordion-btn')
    ]
    const isActiveClass = 'is-active'

    faqAccordionBtns.forEach(btn => {
      let isAccordionOpen = false

      btn.addEventListener('click', () => {
        isAccordionOpen = !isAccordionOpen

        const accordionItem = btn.parentNode
        const accordionContent = accordionItem.querySelector(
          '.js-faq-accordion-content'
        )

        if (isAccordionOpen) {
          accordionItem.classList.add(isActiveClass)
          accordionContent.style.maxHeight =
            accordionContent.scrollHeight + 'px'
        } else {
          accordionItem.classList.remove(isActiveClass)
          accordionContent.style.maxHeight = null
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core/faq-accordion.js